export default function faqsubject(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                faqsubject: action.faqsubject,
            }
        default:
            return state;
    }
}
